export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $auth, $login, $api, ssrContext, $stage } = useNuxtApp();
  let providerCookieName = $api.tenant?.default?.autoLogin?.providerCookieName;
  const providerCookieValue = useCookie(providerCookieName)?.value;
  const userTokenValue = useCookie('user-token')?.value
  if (
    ($auth.user?.roles[0] !== 'user' && !userTokenValue) &&
    !to?.query?.code &&
    providerCookieName &&
    useCookie(providerCookieName)?.value
  ) {
    if (import.meta.server) {
      return await $login.serverRedirectToLogin(
        ssrContext?.event?.node?.req,
        to,
        navigateTo,
        true
      );
    } else {
      await $login.login();
    }
  }  

  // O2-DE auto logout flow
  // if (
  //   $stage === 'liv' &&
  //   providerCookieName &&
  //   !providerCookieValue &&
  //   to.path !== '/external/logout'
  // ) {
  //   // clean tefJwt for vf-de
  //   const jwtCookieObj = useCookie('tefJwt', {
  //     domain: '.o2online.de', // Specify the domain of the cookie you want to remove
  //     path: '/', // Apply removal across all paths
  //   });
  //   jwtCookieObj.value = null; // This will clear the cookie
  //   if ($auth.user?.roles[0] == 'user') {
  //     return navigateTo('/external/logout');
  //   }
  // }

});
